// extracted by mini-css-extract-plugin
module.exports = {"navbar":"showRoomNavbar-module--navbar--2_Zpp"};